import type { GetServerSidePropsContext } from 'next';
import { IBrandFeaturesConfig } from '@pro/brand/interface';
import api from 'base/utils/api';

export async function getFeaturesConfig(mock: boolean, theme?: string | string[]): Promise<IBrandFeaturesConfig> {
    if (mock) {
        return api.get('/api/featureConfig/brand', {
            params: {
                theme
            }
        });
    }
    return api.get('/web/featureConfig/homepage', {
        params: {
            name: 'homepage',
        }
    });
}

export async function getServerSideProps({ query }: GetServerSidePropsContext) {
    const serverProps = await getFeaturesConfig(query.mock === '1', query.theme).catch(() => {
        return null;
    });

    return serverProps ? {
        props: serverProps,
    }: {
        notFound: true,
    }
}
